import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Constants } from '@app/constants/constants';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { Branch } from '@app/models/branch';
import { SavingAgreementApproval } from '@app/models/saving-agreement-approval';
import { SavingAgreementInterestPayment } from '@app/models/saving-agreement-interest-payment';
import { AuthenticationService } from '@app/services/authentication.service';
import { NotificationService } from "@app/services/notification.service";
import { SavingAgreementsService } from '@app/services/saving-agreements.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-saving-agreement-interest-payment-popup',
    templateUrl: './saving-agreement-interest-payment-popup.component.html',
    styleUrls: ['./saving-agreement-interest-payment-popup.component.css'],
    standalone: false
})

export class SavingAgreementInterestPaymentPopupComponent implements OnInit {

  @Input() savingAgreementApproval: SavingAgreementApproval;
  @Input() branches: Array<Branch>;

  @Input() displayDialog: boolean;
  @Output() onSubmit = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  @ViewChild('form') form: any;

  submittedForm: boolean = false;
  calculationBranchId: string;
  branchCodeDefault: string;

  yearRange: string;
  selectedCurrency: string;

  savingAgreementInterestPayment: SavingAgreementInterestPayment;
  amount: number;

  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private savingAgreementsService: SavingAgreementsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.yearRange = MethodsHelper.getYearRange(0);
    if (!MethodsHelper.haveValue(this.calculationBranchId)) {
      this.calculationBranchId = this.authenticationService.getCurrentBranchId();
    }
  }

  ngOnChanges() {
    this.savingAgreementInterestPayment = new SavingAgreementInterestPayment();
    this.savingAgreementInterestPayment.date = this.formatStringDate(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date());
    this.savingAgreementInterestPayment.agreementNumber = this.savingAgreementApproval.savingAgreementNumber;
    this.getSavingAgreementInterestPayment();
    this.selectedCurrency = this.getCurrencyCode();
  }

  cancel() {
    this.onCancel.emit();
  }

  onSave() {
    this.saveData();
  }

  validateForm() {
    if (this.form.form) {
      return this.form.form.valid
    }
    return false;
  }

  getCurrencyCode() {
    return this.savingAgreementInterestPayment?.currency;
  }

  getSavingAgreementInterestPayment() {
    if (this.savingAgreementApproval?.id) {
      this.getPaymentSummary(this.savingAgreementApproval.id)
    }
  }

  formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString('default', { day: '2-digit' });
    const month = date.toLocaleString('default', { month: 'numeric' });
    const year = date.toLocaleString('default', { year: 'numeric' });
    return year + '-' + month + '-' + day;
  }

  formatStringDate(date) {
    const currentDate = date;
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Note: Months are zero-based
    const year = currentDate.getFullYear();

    return `${day}-${month}-${year}`;
  }

  getPaymentSummary(savingAgreementId) {
    this.savingAgreementsService.getPaymentSummary(savingAgreementId, this.savingAgreementInterestPayment.date).subscribe({
      next: (data) => {
        let bkItem = this.savingAgreementInterestPayment;
        this.savingAgreementInterestPayment = data;
        
        if(!MethodsHelper.haveValue(this.savingAgreementInterestPayment.date)){
          this.savingAgreementInterestPayment.date = bkItem.date;
        }

        if(!MethodsHelper.haveValue(this.savingAgreementInterestPayment.agreementNumber)){
          this.savingAgreementInterestPayment.agreementNumber = bkItem.agreementNumber;
        }
        this.selectedCurrency = this.getCurrencyCode();
        
        // this.amount = this.savingAgreementInterestPayment.interestAmount - this.savingAgreementInterestPayment.taxAmount;
        // this.savingAgreementInterestPayment.totalAmount = this.amount + this.savingAgreementInterestPayment.taxAmount;
      },
      error: (error) => {
        this.notificationService.showErrorMessage(MethodsHelper.showErrorMessageStyling(error));}
    });
  }

  saveData() {
    this.submittedForm = true;
    let newDate: string | Date = this.savingAgreementInterestPayment.date;

    if (this.validateForm()) {
      let submittedData = {
        documentNumber: this.savingAgreementInterestPayment.documentNumber,
        date: newDate,
        description: this.savingAgreementInterestPayment.description,
        paymentType: "NON_CASH",
        customerSpecificOptions: [
          {
            customerId: this.savingAgreementInterestPayment.customerSpecificOptions[0].customerId
          }
        ],
        initiatedUserId: this.authenticationService.getCurrentUserId(),
        channelCode: Constants.CHANNEL.CHANNEL_CODE,
        branchId: this.calculationBranchId,
        cashDeskId: ""
      };
      this.savingAgreementsService.pay(this.savingAgreementApproval.id, submittedData).subscribe({
        next: () => {
          this.notificationService.showSuccessMessage(this.translate.instant('savings.interest_payment_done'), "");
          this.onSubmit.emit();
        },
        error: (error) => {
          this.notificationService.showErrorMessage(`${MethodsHelper.showErrorMessageStyling(error)}`);}
      });
    }
  }

  onTaxAmountChange(value) {
    this.savingAgreementInterestPayment.taxAmount = value;
    this.amount = this.savingAgreementInterestPayment.interestAmount - this.savingAgreementInterestPayment.taxAmount;
    this.savingAgreementInterestPayment.totalAmount = this.amount + this.savingAgreementInterestPayment.taxAmount;
  }

    onDateChange(date: string) {
        if (date && date.length === 10) {
            this.getSavingAgreementInterestPayment();
        }
    }
}
